import RichText from "@/components/atoms/rich-text/rich-text";
import { TextButton } from "@/components/molecules/cta-button/cta-buttons";

type ConfirmationModalProps = {
  modalSubText?: string;
  modalConfirmBtnText?: string;
  modalCancelBtnText?: string;
  modalConfirmBtnClick?: (click: boolean) => void;
};

function MTAErrorModal({
  modalSubText,
  modalConfirmBtnText,
  modalConfirmBtnClick,
}: Readonly<ConfirmationModalProps>) {
  return (
    <div className=" flex justify-center w-full flex-col">
      <RichText
        richText={modalSubText || ""}
        className="text-center mb-spacing-l text-xs leading-[27px] font-normal"
      />
      <div className="flex md:flex-row flex-col">
        <TextButton
          id="modal-confirm-button"
          hierarchy="primary"
          data-testid="confirm-button"
          label={modalConfirmBtnText as string}
          onClick={() => {
            if (modalConfirmBtnClick) {
              modalConfirmBtnClick(true);
            }
          }}
          className="min-w-[278px] md:min-w-[304px] h-size-xl w-full text-[18px] font-body-font min-h-[48px] font-[600] leading-[100%] gap-spacing-xs md:gap-[2px]"
        />
      </div>
    </div>
  );
}

export default MTAErrorModal;
